// extracted by mini-css-extract-plugin
module.exports =  {"seller-info":"rtqqqOO","sellerInfo":"rtqqqOO","compact-view":"sJUAh9H","compactView":"sJUAh9H","separation-ellipse":"b6Nx1x6","separationEllipse":"b6Nx1x6"};